module.exports = __webpack_public_path__ + "static/img/MJ116.2af3c50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/MJ116.jpg
// module id = hAG+
// module chunks = 1